import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Box, Button, Flex, H4, Small, Text } from '@bigcommerce/big-design';

import { getAppMessages, dismissAppMessage } from '../../redux/actions/appMessages';

const AppMessages = ({ payload, loadMessages, dismissMessage }) => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    loadMessages(payload)
      .then((response) => setMessages(response.data.messages || []))
      .catch(() => null);
  }, [payload]);

  const dismiss = (messageId) => {
    setMessages(messages.filter((message) => message.uuid !== messageId));
    dismissMessage(payload, messageId).catch(() => null);
  }

  return (
    <>
      { messages.map((message) =>
        <Box
          key={message.uuid}
          backgroundColor="primary10"
          border="box"
          borderRadius="normal"
          marginBottom="medium"
          padding="medium"
        >
          <Flex justifyContent="space-between" alignItems="flex-start">
            <Flex flexDirection="column" flexGrow={1}>
              <H4 margin="none">{message.title}</H4>
              <div style={{ whiteSpace: 'pre-wrap' }}><Text>{message.message}</Text></div>
              <Small>{message.created_at}</Small>
            </Flex>
            <Button variant="subtle" onClick={() => dismiss(message.uuid)}>Dismiss</Button>
          </Flex>
        </Box>
      ) }
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  loadMessages: (payload) => dispatch(getAppMessages(payload)),
  dismissMessage: (payload, messageId) => dispatch(dismissAppMessage(payload, messageId)),
});

export default connect(null, mapDispatchToProps)(AppMessages);
